import { render } from "./UpdateMessage.vue?vue&type=template&id=1439cbc8"
import script from "./UpdateMessage.vue?vue&type=script&lang=js"
export * from "./UpdateMessage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\TEMP\\Website_Corneel\\luisterlive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__